/* LinksRenderer.js */

"use strict";

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("oslinks-links-column");
        this._rootElem.component = this._model;

        this._OsLinkEditIcon = document.createElement("actionable-icon-gl");
        this._OsLinkEditIcon.dataset.icon = "common.edit";
        this._OsLinkEditIcon.setAttribute("title", "Edit Instructions");

        this._OsLinkUploadIcon = document.createElement("actionable-icon-gl");
        this._OsLinkUploadIcon.dataset.icon = "common.upload";
        this._OsLinkUploadIcon.setAttribute("title", "Upload Instructions");

        this._OsLinkDeleteIcon = document.createElement("actionable-icon-gl");
        this._OsLinkDeleteIcon.dataset.icon = "common.trash_bin";
        this._OsLinkDeleteIcon.setAttribute("title", "Delete Instructions");

        this._registerListeners();
        this.render();
    }

    /* *******************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS  */
    /* *******************************************/

    _shutdown() {
        return new Promise((resolve) => {
            this._unregisterListeners();
            this._OsLinkEditIcon.remove();
            this._OsLinkEditIcon = undefined;
            this._OsLinkUploadIcon.remove();
            this._OsLinkUploadIcon = undefined;
            this._OsLinkDeleteIcon.remove();
            this._OsLinkDeleteIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._OsLinkEditIcon.addEventListener(
            "click",
            (this._onClickOsLinkEditIcon = this._onClickOsLinkEditIcon.bind(this))
        );
        this._OsLinkUploadIcon.addEventListener(
            "click",
            (this._onClickOsLinkUploadIcon = this._onClickOsLinkUploadIcon.bind(this))
        );
        this._OsLinkDeleteIcon.addEventListener(
            "click",
            (this._onClickOsLinkDeleteIcon = this._onClickOsLinkDeleteIcon.bind(this))
        );
    }

    _unregisterListeners() {
        this._OsLinkEditIcon.removeEventListener("click", this._onClickOsLinkEditIcon);
        this._OsLinkUploadIcon.removeEventListener("click", this._onClickOsLinkUploadIcon);
        this._OsLinkDeleteIcon.removeEventListener("click", this._onClickOsLinkDeleteIcon);
    }

    _onClickOsLinkEditIcon() {
        this._model.manageInstruction();
    }

    _onClickOsLinkUploadIcon() {
        this._model.manageInstruction();
    }

    _onClickOsLinkDeleteIcon() {
        this._model.deleteInstruction();
    }

    /* ******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS   */
    /* START PUBLIC COMPONENT RENDERER METHODS  */
    /* ******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setIcons(this._model);
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* ******************************************/
    /* END COMPONENT RENDERER METHODS           */
    /* START HANDLER METHODS                    */
    /* ******************************************/

    /* ******************************************/
    /* END HANDLER METHODS                      */
    /* START PRIVATE API METHODS                */
    /* ******************************************/

    _setIcons({_isEditDisabled, _isUploadDisabled}) {
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._OsLinkEditIcon);
        this._OsLinkEditIcon.setDisabled(_isEditDisabled);
        this._rootElem.appendChild(this._OsLinkUploadIcon);
        this._OsLinkUploadIcon.setDisabled(_isUploadDisabled);
        this._rootElem.appendChild(this._OsLinkDeleteIcon);
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
